const PIN_CODE_PATTERN = /^\d{4,8}$/;

export function normalizePinCodeInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, 8);
}

export function isValidPinCode(value: string): boolean {
  return PIN_CODE_PATTERN.test(value.trim());
}

